var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 269,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m156 164.5-1.7.6a2.3 2.3 0 0 1-3.1-1.5l-9.2-30.9L37.3 164l25 83.9a11.5 11.5 0 0 0 14.3 7.8l82.6-24.6a11.5 11.5 0 0 0 7.8-14.4l-6-19.8a2.3 2.3 0 0 1 1.8-3c.6 0 1.2-.2 1.8-.4 8.7-2.6 13.8-11.1 11.4-19.1-2.4-8-11.3-12.4-20-9.8Z",
    fill: "#629E94"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128 243.3s-45.8 12.9-56 5.4c-8.4-6.3-8.8-12.7-20.9-38.3-.1 22 11.9 58.1 11.9 58.1l65-25.2Z",
    fill: "#99ADF9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3 156.4S80.8 177.8 97 173c16.2-4.8 8.2-25.2 8.2-25.2l-28.9 8.6Z",
    fill: "#629E94",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7 37.8 20.1 65.7A11.5 11.5 0 0 0 12.3 80l25 84 36-10.8a2.1 2.1 0 0 1 2.6 1.7l.4 1.6c2.6 8.6 11.2 13.7 19.1 11.4 8-2.4 12.4-11.4 9.8-20l-.5-1.6a2.1 2.1 0 0 1 1.4-2.8l35.9-10.7-28.3-95Z",
    fill: "#B0CECA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 130S12.5 84 20 74c6.3-8.5 17.4-13.5 30.6-17.4C28.5 56.5 0 65 0 65l25.2 65Z",
    fill: "#B0CECA",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m113.7 37.8 8 27a3.1 3.1 0 0 1-2.4 4l-2.5.6C108 72 103 80.6 105.4 88.5c2.4 8 11.3 12.4 20 9.8l2.4-.9a3.2 3.2 0 0 1 4.3 2l9.9 33.3 34.2-10.1a3.9 3.9 0 0 0 2.6-4.9c-2.6-8.7 1.7-17.7 9.7-20 8-2.4 16.6 2.7 19.2 11.3v.1a3.9 3.9 0 0 0 4.8 2.6l23.1-6.8a11.5 11.5 0 0 0 7.8-14.4l-21.7-72.8a11.5 11.5 0 0 0-14.3-7.8l-93.7 27.9Z",
    fill: "#81B1AA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.8 69.4s-9 4.8-5.7 15.8c3.2 11 11 12.4 16 13.3-9.1 8-35.9-3-35.9-3l10.1-27.1 15.5 1ZM236.8 68.2s-14.3-45.4-26-49.8c-10-3.6-24.1-5-37.3-1C192 5.1 222.4 0 222.4 0l14.4 68.2Z",
    fill: "#81B1AA",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 107.7a5.5 5.5 0 1 0 0-11.1 5.5 5.5 0 0 0 0 11ZM90.8 95.4a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM67.2 109s.2-4.3 5.3-5.8c5-1.6 7.4 2 7.4 2",
    fill: "#4E7E77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 109s.2-4.3 5.3-5.8c5-1.6 7.4 2 7.4 2",
    stroke: "#4E7E77",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 204a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM125.3 191.8a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM161.4 68.9c.8 3-1.3 4.3-4.3 5.2-2.9.9-5.5.9-6.4-2a5.5 5.5 0 1 1 10.7-3.2ZM202.4 56.7c1 3-1.3 4.3-4.2 5.2-3 .9-5.5.9-6.4-2a5.5 5.5 0 1 1 10.6-3.2ZM189 73.3c-.2 2.8-3.6 2.5-8.5 4-5 1.5-7.3 3.9-9.3 1.3-2.6-3.2 1.8-8.3 6.7-9.8 5-1.4 11.4.4 11 4.5ZM116.9 197.6 97 203.5a3.6 3.6 0 1 0 2 6.8l20-6a3.6 3.6 0 0 0-2.1-6.8Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m206.2 183 5.5 10M217.9 148.7l10.4-4.8M217.3 167.2l13.3 4.4",
    stroke: "#34544F",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.8270cbca27b303f4914bfa5c8c23c0c0.svg";
export { ForwardRef as ReactComponent };